export default class SearchLexique {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

        // On change event on #search, do an ajax call with the value of the input on data-url
        $('#search').on('input', function() {
            let url = $(this).attr('data-url');
            let value = $(this).val();
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    search: value
                },
                success: function(data) {
                    $('#search-results').html(data.view);
                }
            });
        });

        // Permet de fermer les résultats de recherche si l'utilisateur clique en dehors du champ de recherche ou des résultats
        document.addEventListener('click', function(event) {
          const results = document.getElementById('search-results');
          const searchInput = document.getElementById('search');

          // Vérifie si le clic est en dehors du champ de recherche et des résultats
          if (!results.contains(event.target) && !searchInput.contains(event.target)) {
            results.style.display = 'none';
          }
        });

        // Permet de réafficher les résultats de recherche lorsque l'utilisateur clique sur le champ de recherche
        document.getElementById('search').addEventListener('focus', function() {
          const results = document.getElementById('search-results');
          results.style.display = 'block';
        });

    }
}
